/**
 * The ambassador's seal, beside the creator's name. Sized in `em`, so it tracks
 * whatever it sits next to rather than a breakpoint.
 *
 * It leans on purpose: a seal is pressed by hand, and a mark set square to the
 * grid reads as an icon in a toolbar rather than a stamp.
 *
 * IT TRAILS THE NAME, decided 2026-08-22, at a known cost: when a wrapping
 * name's last line lands almost exactly full, WebKit drops the seal onto a
 * line of its own. Nothing from inside the line fixes it — a width
 * reservation, a word joiner and a zero-advance box were each measured
 * failing — and `overflow-wrap: break-word` on the heading only removes the common half, an
 * unbreakable name overflowing the column. Leading the name is the version
 * that cannot break, and it was rejected: a seal is stamped after a name, not
 * bulleted before it.
 *
 * Twelve quadratic arcs, not a sampled polygon: for a quadratic Bezier the
 * curve's midpoint is (P0 + 2C + P2)/4, so each control point is solved to put
 * that midpoint on the peak radius. The control points sit outside the viewBox
 * and never render.
 */
export function AmbassadorMark() {
  return (
    <span
      role="img"
      aria-label="Meetmy Ambassador"
      title="Meetmy Ambassador"
      className="ml-[0.16em] inline-flex size-[0.62em] shrink-0 -translate-y-[0.06em] -rotate-12 items-center justify-center align-middle"
    >
      {/* The seal is stroked as well as filled. Lime on the storefront's cream
            ground is barely 1.3:1 — the tick reads but the lobes dissolve — so
            the rim gives the shape its silhouette back, which a struck seal has
            anyway. The rim takes `--sf-ground-fg`, so it is ink on the light
            ground and white on the dark one: a fixed ink rim would vanish into a
            dark page exactly the way the lime vanished into a light one. */}
      <svg viewBox="0 0 100 100" fill="none" aria-hidden className="size-full">
        <path
          d="M50 10Q65.9-9.3 70 15.4Q93.4 6.6 84.6 30Q109.3 34.1 90 50Q109.3 65.9 84.6 70Q93.4 93.4 70 84.6Q65.9 109.3 50 90Q34.1 109.3 30 84.6Q6.6 93.4 15.4 70Q-9.3 65.9 10 50Q-9.3 34.1 15.4 30Q6.6 6.6 30 15.4Q34.1-9.3 50 10Z"
          fill="var(--sf-lime)"
          stroke="var(--sf-ground-fg)"
          strokeWidth="5"
          strokeLinejoin="round"
        />
        <path
          d="M33 51l12 12 24-24"
          stroke="var(--sf-on-lime)"
          strokeWidth="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
